import { render, staticRenderFns } from "./PauseOK.vue?vue&type=template&id=62ba3ab7&scoped=true&"
import script from "./PauseOK.vue?vue&type=script&lang=js&"
export * from "./PauseOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba3ab7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62ba3ab7')) {
      api.createRecord('62ba3ab7', component.options)
    } else {
      api.reload('62ba3ab7', component.options)
    }
    module.hot.accept("./PauseOK.vue?vue&type=template&id=62ba3ab7&scoped=true&", function () {
      api.rerender('62ba3ab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PauseOK.vue"
export default component.exports